import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { SplashPreview } from "./SplashPreview.tsx";
import { PlatformSessionProvider } from "./session/PlatformSessionProvider.tsx";
import "./styles.css";
import "@fulcrum5/suite-ui/styles.css";

const root = document.getElementById("root");

if (!root) throw new Error("Platform root element is missing");

const previewSplash =
  typeof window !== "undefined"
  && new URLSearchParams(window.location.search).get("previewSplash") === "1";

createRoot(root).render(
  <StrictMode>
    {previewSplash ? (
      <SplashPreview />
    ) : (
      <PlatformSessionProvider>
        <App />
      </PlatformSessionProvider>
    )}
  </StrictMode>,
);
